import { render, staticRenderFns } from "./consumablePurchase.vue?vue&type=template&id=6ce9583a&scoped=true"
import script from "./consumablePurchase.vue?vue&type=script&lang=js"
export * from "./consumablePurchase.vue?vue&type=script&lang=js"
import style0 from "./consumablePurchase.vue?vue&type=style&index=0&id=6ce9583a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ce9583a",
  null
  
)

export default component.exports